import { BaseService } from "./base.service";

export class TokenService extends BaseService {
  async verifyKey(key: string) {
    await this.client.post("/identity/token/key/verify", { key });
  }
}
